import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const ChipsWrapper = styled(FlexRow)`
    gap: 8px;
    align-items: center;
`;

export const AIInputTitle = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[250])};
    margin: 0;
    padding: 0;
`;
